import type { IconSvgObject } from './types';

const Share05Icon: IconSvgObject = [
  ["path", { d: "M19.0001 13V19C19.0001 20.1046 18.1046 21 17.0001 21H5.00006C3.89549 21 3.00006 20.1046 3.00006 19V7C3.00006 5.89543 3.89549 5 5.00006 5H11.0001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 3H21V10M20.5 3.5L11 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Share05Icon;
